import { useEffect, useState } from "react";

// Calls `onMidnight` at 12:01am local time, then reschedules for the next day.
export function useMidnightRefresh(onMidnight) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const now = new Date();
    const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 1, 0, 0);
    const delay = Math.max(1000, next.getTime() - now.getTime());
    const t = setTimeout(() => {
      onMidnight();
      setTick((n) => n + 1);
    }, delay);
    return () => clearTimeout(t);
  }, [onMidnight, tick]);
}
